export type DatasetLabelColorOption = {
  name: string
  bgColor: string
  textColor: string
}

export const datasetLabelPresetColors: DatasetLabelColorOption[] = [
  {
    name: 'Default',
    bgColor: '#1a4b8c1f',
    textColor: '#3b82f6',
  },
  {
    name: 'Yellow',
    bgColor: '#ffd70029',
    textColor: '#ffd700',
  },
  {
    name: 'Green',
    bgColor: '#0d9b0d1f',
    textColor: '#4caf50',
  },
  {
    name: 'Pink',
    bgColor: '#8000ff1f',
    textColor: '#9333ea',
  },
  {
    name: 'Orange',
    bgColor: '#ff80001f',
    textColor: '#ff8000',
  },
  {
    name: 'Gray',
    bgColor: '#00000012',
    textColor: '#00000099',
  },
]

export type DatasetLabelColorOptionName =
  (typeof datasetLabelPresetColors)[number]['name']
